import { useSyncExternalStore } from 'react';

let hoveredAccountId = null;
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function setHoveredProjectAccountId(accountId) {
  hoveredAccountId = accountId;
  emit();
}

export function clearHoveredProjectAccountId() {
  hoveredAccountId = null;
  emit();
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return hoveredAccountId;
}

export function useHoveredProjectAccountId() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useIsProjectAccountHovered(accountId) {
  const currentHoveredAccountId = useHoveredProjectAccountId();
  return currentHoveredAccountId === accountId;
}
